export default __webpack_public_path__ + "static/media/grimhunger.5d5880aa.png";